import React, { useState, useEffect, useRef } from "react";
import {
  CtxWrap,
  DotsBtn,
  DropMenu,
  DropItem,
  G,
  IcoMoreVertical,
  IcoEdit,
  DropDivider,
  IcoArrowUp,
  IcoArrowDown,
  IcoTrash,
  IcoUpload,
  IcoDownload,
} from "./styles";

const SubFolderContextMenu = ({
  sf,
  sfIdx,
  totalSf,
  onRename,
  onMoveUp,
  onMoveDown,
  onDelete,
  onUpload,
  onCombine,
  onCopyTo,
  onDownload,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const act = (fn) => {
    fn();
    setOpen(false);
  };

  return (
    <CtxWrap ref={ref}>
      <DotsBtn
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        $open={open}
      >
        <IcoMoreVertical size={14} color={G.slate500} />
      </DotsBtn>
      {open && (
        <DropMenu
          style={{
            minWidth: 190,
          }}
        >
          <DropItem onClick={() => act(() => onRename(sf.code))}>
            <IcoEdit size={12} color={G.slate500} />
            <span>Rename Folder</span>
          </DropItem>
          <DropDivider />
          <DropItem
            $disabled={sfIdx === 0}
            onClick={() => {
              if (sfIdx > 0) act(() => onMoveUp(sfIdx));
            }}
          >
            <IcoArrowUp
              size={12}
              color={sfIdx === 0 ? G.slate300 : G.slate500}
            />
            <span>Move Up</span>
          </DropItem>
          <DropItem
            $disabled={sfIdx === totalSf - 1}
            onClick={() => {
              if (sfIdx < totalSf - 1) act(() => onMoveDown(sfIdx));
            }}
          >
            <IcoArrowDown
              size={12}
              color={sfIdx === totalSf - 1 ? G.slate300 : G.slate500}
            />
            <span>Move Down</span>
          </DropItem>
          <DropDivider />
          {onUpload && (
            <DropItem onClick={() => act(onUpload)}>
              <IcoUpload size={12} color={G.slate500} />
              <span>Upload Files to Folder</span>
            </DropItem>
          )}
          {/* {onCombine && (
            <DropItem onClick={() => act(onCombine)}>
              <IcoCombine size={12} color={G.slate500} />
              <span>Combine Bundle</span>
            </DropItem>
          )}
          {onCopyTo && (
            <DropItem onClick={() => act(onCopyTo)}>
              <IcoCopy size={12} color={G.slate500} />
              <span>Copy to Bundle</span>
            </DropItem>
          )} */}
          {onDownload && (
            <DropItem onClick={() => act(onDownload)}>
              <IcoDownload size={12} color={G.slate500} />
              <span>Download Folder</span>
            </DropItem>
          )}
          <DropItem onClick={() => act(() => onDelete(sf.code))} $danger>
            <IcoTrash size={12} color={G.red} />
            <span>Delete Sub-folder</span>
          </DropItem>
          <DropDivider />
        </DropMenu>
      )}
    </CtxWrap>
  );
};

export default SubFolderContextMenu;
